import React from 'react';
import { useDeleteEdge } from 'services/Edges';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
// @ts-ignore
import styled from 'styled-components/macro';

const Label = styled.label`
  margin-bottom: 0;

  &:hover {
    cursor: pointer;  
  }
`;

function DeleteEdge({ edge, className = '' }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const deleteEdge = useDeleteEdge(edge);

  const handleDelete = () => {
    setIsOpen(false);
    deleteEdge().then(() => {
      window.location.reload();
    });
  }

  return (
    <>
      <Label style={{ color: 'red' }} onClick={() => setIsOpen(!isOpen)} className={className}>
        Delete
      </Label>

      <Modal isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
        <ModalHeader>Edge: {edge}</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to continue?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsOpen(!isOpen)}>Cancel</Button>
          <Button color="danger" onClick={handleDelete}>Delete</Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default DeleteEdge
